module.exports = __webpack_public_path__ + "static/media/img_feature_photo3@2x.104b44ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_feature_photo3@2x.png
// module id = 805
// module chunks = 0